import React from 'react'
import { RootNotAllowed, Image404 } from './ManageParticipants.styles'
import { Typography } from '@chilecompra/react-kit'
import { PUBLIC_URL } from '../../config/settings/environment'

/**
 * The Manage Participant not allowed component.
 */
const ManageParticipantsNotAllowed = () => {
  return (
    <RootNotAllowed>
      <Typography fontSize="34px" color="black1" fontWeight="regular" variant="h3" align="center" padding="20px 0 0">
        Esta información no está disponible
      </Typography>
      <Image404 alt="No tiene permisos suficientes para ver el contenido" src={`${PUBLIC_URL}/assets/images/404.svg`} />
    </RootNotAllowed>
  )
}

export default ManageParticipantsNotAllowed
